/* eslint-disable arrow-parens */
import React from "react";
import "./EnrollmentModal.css"; // Or use styled-components/CSS-in-JS if preferred

interface EnrollmentModalProps {
	isOpen: boolean;
	onClose: () => void;
	planNames: string[];
}

export const EnrollmentModal: React.FC<EnrollmentModalProps> = ({ isOpen, onClose, planNames }) => {
	if (!isOpen) return null;

	return (
		<div className="modal-overlay" onClick={onClose}>
			<div className="modal-container" onClick={(e) => e.stopPropagation()}>
				<div className="modal-header">
					<div className="success-icon">
						<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
							<path d="M20 6L9 17l-5-5" strokeLinecap="round" strokeLinejoin="round" />
						</svg>
					</div>
					<h2>Open Enrollment Active</h2>
					<button className="close-btn-n" onClick={onClose} aria-label="Close modal">
						<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
							<path d="M18 6L6 18M6 6l12 12" strokeLinecap="round" strokeLinejoin="round" />
						</svg>
					</button>
				</div>

				<div className="modal-body">
					<p className="modal-subtitle">You have successfully enrolled in the following plans:</p>
					<div className="plans-list">
						{planNames.map((plan, index) => (
							<div key={index} className="plan-item">
								<div className="plan-bullet">
									<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3">
										<path d="M5 13l4 4L19 7" strokeLinecap="round" strokeLinejoin="round" />
									</svg>
								</div>
								<span className="plan-name">{plan}</span>
							</div>
						))}
					</div>
				</div>

				<div className="modal-footer">
					<button className="btn-primary" onClick={onClose}>
						Got it, thanks!
					</button>
				</div>
			</div>
		</div>
	);
};
